<template>
  <main>
    <modalEducacionesList
      :idUsuario="idUsuario"
      :usuario="usuario"
      ref="listEducaciones"
      v-on:cargar-ultima="cargarUltimaEducacion(idUsuario)"
    />
    <modalEducacionCreate
      :idUsuario="idUsuario"
      :usuario="usuario"
      :edad="edad"
      ref="createEducacion"
      v-on:educacion-guardada="cargarUltimaEducacion(idUsuario)"
    />

    <div class="card-header bg-light border-bottom-0">
      <div class="row align-items-center w-100">
        <div class="col-6 font-weight-bold text-gray-600 h6 mb-0">
          <i class="fas fa-book-open mr-2 text-primary"></i> Educación Grupal
        </div>
        <div class="col-6 d-flex justify-content-end">
          <button
            class="btn btn-primary btn-xs btn-icon"
            type="button"
            title="Agregar Educación"
            @click="nuevaEducacion"
          >
            <i class="fas fa-plus"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <span class="text-muted small font-weight-bold">Última Educación</span>
        <span v-if="ultima_educacion && ultima_educacion.fecha" class="text-bold font-weight-bold">
          {{ fechaFormateada(ultima_educacion.fecha) }}
        </span>
        <span v-else class="badge badge-light text-danger font-italic small">Sin datos...</span>
      </div>
      <div v-if="ultima_educacion && ultima_educacion.educacion" class="small text-secondary mb-2 text-truncate font-weight-bold">
        {{ ultima_educacion.educacion.nombre }}
      </div>
      <div class="d-flex mt-2">
        <button
          @click="historialEducaciones"
          type="button"
          class="btn btn-light btn-sm flex-fill text-primary font-weight-bold mr-1"
        >
          Ver Educaciones <i class="far fa-eye fa-fw"></i>
        </button>
        <button
          v-if="ultima_educacion && ultima_educacion.id"
          @click="imprimirEducacion(ultima_educacion.id)"
          type="button"
          class="btn btn-light btn-sm text-info font-weight-bold"
          title="Imprimir Última Educación"
        >
          <i class="fas fa-print"></i>
        </button>
      </div>
    </div>
  </main>
</template>

<script>
import $ from "jquery";
import dayjs from "dayjs";
import historiaEducacionService from "@/services/historiaEducacionService";
import modalEducacionesList from "./modalEducacionesList";
import modalEducacionCreate from "./modalEducacionCreate";

export default {
  name: "CardEducaciones",
  props: ["idUsuario", "usuario"],
  components: {
    modalEducacionesList,
    modalEducacionCreate
  },
  data() {
    return {
      ultima_educacion: {}
    };
  },
  methods: {
    fechaFormateada(fecha) {
      if (!fecha) return '';
      return dayjs(fecha).format('YYYY-MM-DD');
    },
    async cargarUltimaEducacion(id) {
      if (!id) return;
      try {
        const res = await historiaEducacionService.showLastByUsuario(id);
        this.ultima_educacion = res.data || {};
      } catch (e) {
        console.error("Error al cargar última educación:", e);
      }
    },
    async historialEducaciones() {
      $("#modalEducacionesList").modal("show");
      this.$refs.listEducaciones.getEducaciones();
    },
    async nuevaEducacion() {
      this.$refs.createEducacion.open();
    },
    imprimirEducacion(id) {
      window.open(historiaEducacionService.print(id));
    }
  },
  watch: {
    idUsuario(newVal) {
      if (newVal) {
        this.cargarUltimaEducacion(newVal);
      }
    }
  },
  computed:{
     edad: function () {
      const now = dayjs();
      return now.diff(this.usuario.fecha_nacimiento, "years");
    },
  },
  async created() {
    if (this.idUsuario) {
      await this.cargarUltimaEducacion(this.idUsuario);
    }
  }
};
</script>
